import axios from 'axios'
import Cookies from 'js-cookie'
import store from '../store'
import router from '../router/index.js'

import { Dialog } from 'buefy'

/* API_BASE from environment variable */
/* eslint-disable no-undef */
const URI_PREFIX = API_BASE

export const CONTENT_TYPE_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
export const CONTENT_TYPE_XML = 'application/xml'
/* there is no official mime type for .spold files but extensions work fine in file input fields */
export const CONTENT_TYPE_ECO_SPOLD2 = '.spold'

axios.defaults.timeout = 0

/**
 * A default action called for every response retrieved by axios.
 *
 * This function is called before axios promises are resolved
 * or rejected and it handles "default errors", currently:
 *   * user is not logged in
 *
 * @param {*} error the http error as received by axios
 */
function axiosDefaultErrorActions(error) {
  let contactSupport = '<br>If this problem persists, please contact support at <a href="mailto:support@ecoinvent.org">support@ecoinvent.org</a> .'
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    let status = error.response.status
    if (status === 401) {
      // unauthorized
      router.push('/login')
    } else if (status === 500) {
      Dialog.alert({
        title: 'Error - Data Conversion',
        message: 'An unexpected error occurred converting your data.' + contactSupport,
        type: 'is-danger'
      })
    } else if (status === 404) {
      // not found
      Dialog.alert({
        title: 'Error - Backend URL',
        message: 'The previous function used an invalid backend URL.' + contactSupport,
        type: 'is-danger'
      })
    }
  } else if (error.request) {
    // The request was made but no response was received (e.g. timeout or network error)
    if (!error.status) {
      Dialog.alert({
        title: 'Error - Timeout Exceeded',
        message: 'We are sorry, the file you uploaded took too long to process. The timeout of ' +
           error.request.timeout + ' milliseconds exceeded.' + contactSupport,
        type: 'is-danger'
      })
      return Promise.resolve()
    } else {
      alert('An unknown error occured.' + contactSupport)
    }
  } else {
    // Something happened in setting up the request that triggered an error
    alert('The current application setup misses a configuration.' + contactSupport)
  }
  return Promise.reject(error)
}

// do not intercept success cases, only error cases
axios.interceptors.response.use(r => r, axiosDefaultErrorActions)

export const initializeJWT = function() {
  let token = Cookies.get('jwtToken')
  let firstName = Cookies.get('firstName')
  let lastName = Cookies.get('lastName')
  if (Cookies.get('disclaimerAccepted')) {
    store.commit('disclaimerAccepted')
  }
  store.commit('name', {'first': firstName, 'last': lastName})
  if (token) {
    axios.defaults.headers.common.Authorization = 'JWT ' + token
    store.commit('login')
  } else {
    delete axios.defaults.headers.common.Authorization
    store.commit('logout')
  }
  axios.defaults.headers.common['Content-Type'] = 'application/json'
}

initializeJWT()

const filesToMultiPartForm = function filesToMultiPartFormF(files) {
  let formData = new FormData()
  for (let file of files) {
    formData.append(file.name, file)
  }
  return formData
}

export const register = function registerF(firstName, lastName, email, password) {
  return axios.post(URI_PREFIX + '/login/register', {
    first_name: firstName,
    last_name: lastName,
    email: email,
    password: password
  })
}

export const verifyEmail = function verifyEmailF(email, token) {
  return axios.post(URI_PREFIX + '/login/verify-email', {
    email: email,
    token: token
  })
}

export const recoverPassword = function recoverPasswordF(email) {
  return axios.post(URI_PREFIX + '/login/recover-password', {
    email: email
  })
}

export const resetPassword = function resetPasswordF(email, token, password) {
  return axios.post(URI_PREFIX + '/login/reset-password', {
    email: email,
    password: password,
    token: token
  })
}

export const login = function loginF(email, password) {
  return axios.post(URI_PREFIX + '/login/token-auth', {
    email: email,
    password: password
  })
    .then((response) => {
      let token = response.data.token
      let firstName = response.data.first_name
      let lastName = response.data.last_name
      store.commit('name', {'first': firstName, 'last': lastName})
      axios.defaults.headers.common.Authorization = 'JWT ' + token
      Cookies.set('jwtToken', token)
      Cookies.set('firstName', firstName)
      Cookies.set('lastName', lastName)
    })
}

export const logout = function logoutF() {
  Cookies.remove('jwtToken')
  store.commit('logout')
}

export const getMasterData = function getMasterDataTemplateF() {
  return axios({
    url: URI_PREFIX + '/masterdata/download',
    method: 'GET',
    headers: { 'accept': CONTENT_TYPE_XLSX },
    responseType: 'blob' // important
  })
}

export const getUMDValidationTime = function getUMDValidationTimeF() {
  return axios.get(URI_PREFIX + '/masterdata/validate')
}
export const getEcoSpold2ConversionTime = function getEcoSpold2ConversionTimeF() {
  return axios.get(URI_PREFIX + '/convert/ecospold/template')
}

export const getTemplateConversionTime = function getTemplateConversionTimeF() {
  return axios.get(URI_PREFIX + '/convert/template/ecospold')
}

export const uploadEcoSpold2 = function uploadEcoSpold2F(files) {
  let formData = filesToMultiPartForm(files)
  return axios.post(URI_PREFIX + '/convert/ecospold/template', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'enctype': 'multipart/form-data'
    }
  })
}

export const uploadTemplate = function uploadTemplateF(files, umd, blame) {
  let formData = filesToMultiPartForm(files)
  formData.append('umd', umd[0])
  formData.append('blaming_mode', blame)
  return axios.post(URI_PREFIX + '/convert/template/ecospold', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'enctype': 'multipart/form-data'
    }
  })
}

export const validateMasterdata = function validateMasterdataF(umd) {
  let formData = filesToMultiPartForm(umd)
  return axios.post(URI_PREFIX + '/masterdata/validate', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'enctype': 'multipart/form-data'
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/api.js